// extracted by mini-css-extract-plugin
export var button = "_d8-4";
export var hasDarkBackground = "_d8-7";
export var hasLightBackground = "_d8-6";
export var iconWrapper = "_d8-0";
export var large = "_d8-2";
export var medium = "_d8-1";
export var small = "_d8-5";
export var xsmall = "_d8-3";